export function getChromeLanguage() {
  return navigator.language || navigator?.userLanguage;
}

export function getChartBufferWidth(defaultWidth: number = 0) {
  let language = getChromeLanguage();
  if (language === 'zh-CN') {
    return defaultWidth;
  }
  return 10;
}

/**
 * TODO: 其他系统使用
 * Hex 颜色值转 rgba
 * @param hex
 * @param opacity
 * @returns
 */
export function hexToRgba(hex: string, opacity: string | number = 1) {
  // 验证输入是否为有效的 Hex 颜色值
  const reg = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
  if (!reg.test(hex)) {
    throw new Error('Invalid hex color value');
  }

  let h = hex.substring(1);

  // 如果 Hex 颜色值是三位数，则将其扩展为六位数
  if (h.length === 3) {
    h = h
      .split('')
      .map((x) => x + x)
      .join('');
  }

  // 将十六进制值转换为十进制值
  const hexValues = h.match(/.{1,2}/g).map((item) => parseInt(item, 16));

  return `rgba(${hexValues[0]}, ${hexValues[1]}, ${hexValues[2]}, ${opacity})`;
}
